import { SIDEBAR } from "./actions";
import initialState from "../../../../reducers/initialState";

const SideBarReducer = (state = initialState, action) => {
  switch (action.type) {
    //initialState
    case SIDEBAR.SET_SIDEBAR_ACTIVE_NUMBER: {
      return {
        ...state,
        activeNumber: action.activeNumber,
      };
    }
    case SIDEBAR.FIXED_SIDEBAR_HANDLER: {
      return {
        ...state,
        sidebarFixed: !state.sidebarFixed,
        dispaySidebar: !state.dispaySidebar,
      };
    }
    default:
      return state;
  }
};

export default SideBarReducer;
